import { LoaderFunctionArgs } from "react-router-dom";
import { api } from "services/api.service";
import { EbayMetadata } from "types/ebayMetadata";

export const loader = async ({ params }: LoaderFunctionArgs) => {
  const response = await api.get<EbayMetadata>(`/ebay_category_metadata/${params.categoryId}`);
  return { metadata: response.data };
};
